import { getController } from '@/services/service'

const url = 'craftsman_task_status_texts'

export const craftsmanTaskStatusTextService = {
	...getController<
		Api.CraftsmanTaskStatusText,
		Api.CraftsmanTaskStatusTextPostInput,
		Api.CraftsmanTaskStatusTextUpdateInput
	>(url),
}

export default craftsmanTaskStatusTextService
